import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { addFiltersToSearchParams } from '@tajawal/web-flights-sdk/lib/utils/filters/common.utils';
import { FilterURLParams } from '@tajawal/web-flights-sdk/lib/types/filters/index.types';
import type { SearchBoxParamsFromUrl } from '@/types/common.types';
import { FILTER_MAP, FILTER_PARAM_MAP } from '@tajawal/web-flights-sdk/lib/constants/filters.constants';
import _omit from 'lodash/omit';
import { FlightsSearchBoxStateCache } from '@/app-common/components/SearchBox/utils/cache.utils';

export default function useAppendFiltersToUrl(
  filtersQuery: FilterURLParams,
  isCompleted: boolean,
  isResourcesFetched: boolean,
  isRoundTrip: boolean
) {
  const [searchBoxParamsFromUrl, setSearchBoxParams] = useState<SearchBoxParamsFromUrl>({
    s: undefined,
    bg: undefined,
  });
  const { query, push } = useRouter();
  let omitedParams = [
    FILTER_PARAM_MAP[FILTER_MAP.AIRPORT],
    FILTER_PARAM_MAP[FILTER_MAP.AIRLINE],
    FILTER_PARAM_MAP[FILTER_MAP.PRICE],
    FILTER_PARAM_MAP[FILTER_MAP.TIME],
  ];

  useEffect(() => {
    let params = addFiltersToSearchParams(query, filtersQuery);
    if (isCompleted && isResourcesFetched) {
      if (isRoundTrip) {
        // @ts-ignore
        omitedParams = [...omitedParams, FILTER_PARAM_MAP[FILTER_MAP.STOP], FILTER_PARAM_MAP[FILTER_MAP.BAGGAGE]];
        params = _omit(params, omitedParams);
      } else {
        FlightsSearchBoxStateCache.syncStorageWithUrl(params);
        setSearchBoxParams({
          s: params?.s,
          bg: params?.bg,
        });
      }
    }

    push({ query: { ...params } }, undefined, { shallow: true });
  }, [filtersQuery, isResourcesFetched, isCompleted, isRoundTrip]);

  return searchBoxParamsFromUrl;
}
